export default {
  IMG_URL: '/static/img',
}



// WEBPACK FOOTER //
// ./src/config.js